module.exports = __webpack_public_path__ + "img/nav_icon_nutrition.001669e3.svg";